document.addEventListener('DOMContentLoaded', function () {
    const cart = document.getElementById('cart');

    const nextSibling = cart.nextElementSibling;
    const secondSibling = nextSibling ? nextSibling.nextElementSibling : null;

    if (secondSibling && secondSibling.classList.contains('add-on-wrapper') && secondSibling.classList.contains('active')) {
        const cartItems = cart.querySelector('.cart__items');
        if (cartItems) {
            cartItems.style.borderBottom = '1px solid #E5E5E5';
        }
    }
});
